<template>
  <div class="layerPopup" id="layer_popup2" style="visibility: visible;">
    <div class="layerBox" style="width:20vw; min-width:260px;">
      <h4 class="title">{{ popList.bSubject }}</h4>
      <div class="cont">
        <p>
          <!-- <img src="../images/popup.jpg" width=350 height=500 usemap="#popup" alt="event page"> -->
          <vue-editor id="notic2" v-model="popList.bContent" :disabled="true" :editor-options="editorOptions" style="height: -webkit-fill-available;"/>
        </p>
      </div>
      <form name="pop_form2">
        <div id="check" ><input type="checkbox" name="chkbox2" value="checkbox" id="chkbox2" >
        <label for="chkbox2">&nbsp;&nbsp;오늘 하루동안 보지 않기</label></div>
        <div id="close" @click="closePop()"><a href="#">닫기</a></div>    
      </form>
    </div>
  </div>
</template>
<script>
export default {
    name:"Notic2",
    props:{        
        popList:{
            type:Object,
            required: false
        }        
    },
    data(){
        return{
            editorOptions : {
                theme:'bubble'
            }
        }   
    },
    mounted(){
        
    },
    methods:{
        setCookie( name, value, expiredays ) {
            var todayDate = new Date();
            todayDate.setDate( todayDate.getDate() + expiredays ); 
            document.cookie = name + "=" + escape( value ) + "; path=/; expires=" + todayDate.toGMTString() + ";"
        },
        closePop() {
            if ( document.pop_form2.chkbox2.checked ){ //소식지 팝업 1개
                console.log("쿠키설정")
                this.setCookie( this.popList.id, "done" , 1 ); //소식지 팝업 1개
            }
            document.all['layer_popup2'].style.visibility = "hidden"; //소식지 팝업 1개
        },
    },

}
</script>

       
<style scoped lang="scss">
/*소식지 팝업*/
.layerPopup img{
margin-bottom : 20px;}
.layerPopup:before {display:block; content:""; position:fixed; left:0; top:0; width:100%; height:100%; z-index:9000}
.layerPopup .layerBox {    z-index:10000;   
position:fixed; left:40%; top:60%; transform:translate(-50%, -50%); padding:20px; background:#fff; border-radius:6px; border: solid 1px #bfbbbb;}
.layerPopup .layerBox .title {margin-bottom:10px; padding-bottom:10px; font-weight:600; border-bottom:1px solid #d9d9d9; font-size:25px;}
.layerPopup .layerBox .btnTodayHide {
font-size:14px; font-weight:600; color:black; 
float: left;text-decoration:none;width: 150px; 
height : 30px;line-height:30px;border:black solid 1px; text-align : center;text-decoration:none;
}
.layerPopup div{
    display : inline;
}
.layerPopup form{
    margin-top : 5px;
    font-size:12px; font-weight:600;
    weight: 100%;
    height : 30px;
    line-height:30px
}
.layerPopup #close {
font-size:12px; font-weight:600; width: 40px; height : 30px;color:black; float: right; line-height:30px; text-align : center;text-decoration:underline;
}
.layerPopup a{
    text-decoration : none;
    color : black;width: 50px;height : 40px;
}

@media (max-width: 600px){
    .layerPopup .layerBox { 
        left:55%; top:49%;
    }
}

</style>
<style>
#notic2{
    height: 200px;
    border: none;
}
</style>
